import Vue from 'vue'
import Vuex from 'vuex'
import wechat from '@/store/modules/wechat';
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    wechat
  }
})
